import { color } from "echarts";
import { useMemo } from "react";
import { LineChartData } from "Components/Charts/Line/Line";
import { useChartTheme } from "Components/Charts/useEChart";
import { useSelector } from "react-redux";
import {
  selectDashboardInspectionSubmissionWeeklyOutcomes,
  selectDashboardInspectionSubmissionWeeklyOutcomesLoading,
} from "Redux/Dashboard/slice";

export const useDashboard = () => {
  const inspectionSubmissionOutcomes = useSelector(
    selectDashboardInspectionSubmissionWeeklyOutcomes,
  );
  const loading = useSelector(
    selectDashboardInspectionSubmissionWeeklyOutcomesLoading,
  );
  const { success, warning } = useChartTheme();

  const data = useMemo<LineChartData[]>(
    () => [
      {
        title: "Count of passed",
        data: inspectionSubmissionOutcomes.data.map(
          (inspection) => inspection.passed_count,
        ),
        itemColor: success,
        areaColor: [
          color.modifyAlpha(success, 1),
          color.modifyAlpha(success, 0),
        ],
      },
      {
        title: "Failed items",
        itemColor: warning,
        areaColor: [
          color.modifyAlpha(warning, 0.5),
          color.modifyAlpha(warning, 0),
        ],
        data: inspectionSubmissionOutcomes.data.map(
          (inspection) => inspection.failed_count,
        ),
      },
    ],
    [inspectionSubmissionOutcomes, success, warning],
  );

  const xAxisLabels = useMemo(
    () => inspectionSubmissionOutcomes.data.map((_, i) => (i + 1).toString()),
    [inspectionSubmissionOutcomes],
  );

  return { data, xAxisLabels, loading };
};
